import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import FormCohabitation from './form';
import {
  CohabitationData,
  DeclarationCohabitationFormVM,
} from 'mutation/view-models/declaration-cohabitation';

const CohabitationComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<DeclarationCohabitationFormVM>();

  const onFieldCohabitationChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('cohabitationData', {
        ...formContext.values.cohabitationData,
        [key]: value,
      });
    },
    [formContext.values.cohabitationData, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-cohabitation-content"
        id="panel-person-cohabitation-header"
        expandIcon={<ExpandMore />}
      >
        {!!formContext.errors.cohabitationData ? (
          <Close color="error" />
        ) : (
          <Check color="success" />
        )}
        <Typography>Dati costituzione convivenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormCohabitation
          values={formContext.values.cohabitationData}
          errors={formContext.errors.cohabitationData as FormikErrors<CohabitationData>}
          touched={
            formContext.touched.cohabitationData as unknown as FormikTouched<CohabitationData>
          }
          onChange={onFieldCohabitationChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

CohabitationComponent.displayName = 'Accordion cohabitation component';

const Cohabitation = memo(CohabitationComponent);

export default Cohabitation;
